import { EVENTS } from '../data/events';
import { ProductType } from "../data/enums";

const lang = new URLSearchParams(window.location.search).get("lang") || "en";

const createEcommerceItem = (product = null) => {
    const item = product ?? getProductAndQuantity().product;
    return {
        item_name: getProductTranslation(item)?.productName || item.name,
        item_id: item.productId?.toString(),
        price: item.productPriceAfterDiscount?.toString() || item.productPrice?.toString(),
        item_brand: getChainName(),
        item_category: 'Ishop',
        item_category2: getProductTypeName(item.productTypeId),
        item_category3: getCategoryName(item) || getProductTypeName(item.productTypeId),
        item_list_name: getPropertyName(item.propertyId),
        item_variant: 'private',
        quantity: getProductAndQuantity()?.quantity || 1,
    };
};
const getCategoryName = (product) => {
    if(product.categories && product.categories.length){
        return product.categories[0].productCategoryName;
    }
    return null;
}

const getProductTranslation = (product) => {
    if (product.translations && product.translations.length) {
        const translation = product.translations.find(t => t.productId == product.productId && lang == t.languageIsoCode);
        return translation ?? null;
    }
    return null;
}
const getProductAndQuantity = () => {
    const products = JSON.parse(sessionStorage.getItem('products')) || null;

    if (products) {
        const firstCartItemKey = Object.keys(products)[0];

        return {
            product: products[firstCartItemKey]?.selectedProduct,
            quantity: products[firstCartItemKey]?.qty,
        };
    }
    return null;
};


export const eventService = {
    viewList: (products) => {
        const ecommerce = { items: products.map(createEcommerceItem) };
        pushDataLayer(EVENTS.VIEW_ITEM_LIST, ecommerce);        
    },
    selectItem: (product) => {
        const ecommerce = { items: [createEcommerceItem(product)] };
        pushDataLayer(EVENTS.SELECT_ITEM, ecommerce);        

    },
    viewItem: (product) => {
        const ecommerce = { items: [createEcommerceItem(product)] };
        pushDataLayer(EVENTS.VIEW_ITEM, ecommerce);        
    },
    addToCart: () => {
        const ecommerce = { items: [createEcommerceItem()] };
        pushDataLayer(EVENTS.ADD_TO_CART, ecommerce);        
    },
    beginCheckout: () => {
        const ecommerce = { items: [createEcommerceItem()] };
        pushDataLayer(EVENTS.BEGIN_CHECKOUT, ecommerce);        
    },
    addPaymentInfo: () => {
        const ecommerce = { items: [createEcommerceItem()] };
        pushDataLayer(EVENTS.ADD_PAYMENT_INFO, ecommerce);        
    },
    purchase: (order) => {
        let price = 0;
        if (order.payments) {
            order.payments.forEach(payment => {
                price += payment.price;
            });
        }
        const ecommerce = {
            currency: "ILS",
            value: price?.toString(),
            transaction_id: order.orderId?.toString(),
            items: [createEcommerceItem()]
        };

        const sessionTransactionId = sessionStorage.getItem("transaction_id");
        if (sessionTransactionId != ecommerce.transaction_id) {
            pushDataLayer(EVENTS.PURCHASE, ecommerce);            
        }
        sessionStorage.setItem("transaction_id", ecommerce.transaction_id);
    }
}
export const pushDataLayer = (event, ecommerce) => {
    const dataObject = {
        event: event,
        ecommerce: ecommerce
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); //reset last object
    window.dataLayer.push(dataObject)
    window.parent.postMessage(JSON.stringify({type:'dataLayer', data: dataObject}), '*');
    console.log(window.dataLayer);
}
export const getProductTypeName = (productTypeId) => {
    switch (productTypeId) {
        case ProductType.OpenValue:
            return 'open value';
        case ProductType.Package:
            return 'package';
        case ProductType.Goods:
            return 'goods';
        case ProductType.Delivery:
            return 'delivery';
        case ProductType.Company:
            return 'company';
        default:
            return '';
    }
};
export const getChainName = () => {
    if (sessionStorage.getItem("chain")) {
        const chain = JSON.parse(sessionStorage.getItem("chain"));
        return chain.name;
    }
    return "";
}
export const getPropertyName = (propertyId) => {
    const properties = sessionStorage.getItem("properties");
    if (properties) {
        const parsedProperties = JSON.parse(properties);
        const property = parsedProperties.find(p => p.propertyId == propertyId);
        if (property) {
            return property.name;
        }
    }
    return "";
}
